import {disableScroll, enableScroll, escapeHtml, normalizeIndex} from '../helpers';
import SvgComponent from './svg';
import ButtonComponent from './button';
import PhotoComponent from './photo';
import ShareComponent from './share';

export default class PopupComponent {
  static CLASSES = {
    POPUP: 'popup popup--photo',
    POPUP_OPEN: 'popup--open',
    POPUP_LOADING: 'popup--loading',
    POPUP_PREPARED: 'popup--prepared',
    CLOSE: 'popup__close',
    HEADER: 'popup__header',
    TITLE: 'popup__title',
    NEXT_LINK: 'popup__next-link',
    SOCIAL: 'popup__social',
    BODY: 'popup__body',
    CONTENT: 'popup__content',
    FOOTER: 'popup__footer',
    PAGE_NUMBER: 'popup__page-number',
    BUTTONS: 'popup__buttons',
    BUTTON: 'popup__button',
    BUTTON_PREV: 'popup__button--prev',
    BUTTON_NEXT: 'popup__button--next'
  };

  static template({
    classList,
    isOpen,
    isLoading,
    items,
    title = '',
    escapeTitle = true,
    nextLink,
    activeIndex = 0
  } = {}) {
    if (escapeTitle) {
      title = escapeHtml(title);
    }

    let attrs = [
      `class="${[
        PopupComponent.CLASSES.POPUP,
        isOpen && PopupComponent.CLASSES.POPUP_OPEN,
        isLoading && PopupComponent.CLASSES.POPUP_LOADING,
        classList && classList.join(' ')
      ]
        .filter((x) => x)
        .join(' ')}"`,
      `data-items="${escapeHtml(JSON.stringify(items || []))}"`
    ]
      .filter((x) => x)
      .join(' ');

    let buttonClose = ButtonComponent.template({
      tag: 'button',
      color: 'red',
      text: 'Закрыть',
      icon: 'close',
      isIconic: true,
      classList: [PopupComponent.CLASSES.CLOSE]
    });

    let url = encodeURI(document.location.href);

    let share = ShareComponent.template({
      isInverse: true,
      isVertical: true,
      socials: [
        {
          type: 'vkontakte',
          text: 'ВКонтакте',
          href: `https://vk.com/share.php?url=${url}`
        },
        {
          type: 'telegram',
          text: 'Telegram',
          href: `tg://msg?text=${url}`
        }
      ]
    });

    let social = `<div class="${PopupComponent.CLASSES.SOCIAL}">${share}</div>`;

    title = title ? `<h4 class="${PopupComponent.CLASSES.TITLE}">${title}</h4>` : '';

    let arrowRight = nextLink ? SvgComponent.template({icon: 'arrow-right'}) : '';

    nextLink = nextLink
      ? `<a class="${PopupComponent.CLASSES.NEXT_LINK}" href="${nextLink.href}">${nextLink.text}${arrowRight}</a>`
      : '';

    let header = `<div class="${PopupComponent.CLASSES.HEADER}">${title}${nextLink}</div>`;
    let photo = items ? PhotoComponent.template(items[activeIndex]) : '';

    let content = `<div class="${PopupComponent.CLASSES.CONTENT}">${photo}</div>`;
    let body = `<div class="${PopupComponent.CLASSES.BODY}">${content}</div>`;

    let footer = '';

    if (items && items.length > 1) {
      let pageNumber = `<div class="${PopupComponent.CLASSES.PAGE_NUMBER}">${activeIndex + 1}/${
        items.length
      }</div>`;

      let buttonPrev = ButtonComponent.template({
        tag: 'button',
        color: 'red',
        text: 'Назад',
        icon: 'arrow-left',
        isIconic: true,
        classList: [PopupComponent.CLASSES.BUTTON, PopupComponent.CLASSES.BUTTON_PREV]
      });

      let buttonNext = ButtonComponent.template({
        tag: 'button',
        color: 'red',
        text: 'Вперед',
        icon: 'arrow-right',
        isIconic: true,
        classList: [PopupComponent.CLASSES.BUTTON, PopupComponent.CLASSES.BUTTON_NEXT]
      });

      let buttons = `<div class="${PopupComponent.CLASSES.BUTTONS}">${buttonPrev}${buttonNext}</div>`;

      footer = `<div class="${PopupComponent.CLASSES.FOOTER}">${pageNumber}${buttons}</div>`;
    }

    let innerHTML = [buttonClose, header, social, body, footer].filter((x) => x).join('');

    return `<div ${attrs}>${innerHTML}</div>`;
  }

  static init($popup) {
    if (!$popup || $popup.popupComponent) {
      return;
    }

    $popup.popupComponent = new PopupComponent($popup);
  }

  static initAll() {
    document.querySelectorAll(`.${PopupComponent.CLASSES.POPUP}`).forEach(($popup) => {
      PopupComponent.init($popup);
    });
  }

  constructor($popup) {
    this.$popup = $popup;
    this.$content = $popup.querySelector(`.${PopupComponent.CLASSES.CONTENT}`);
    this.$photo = $popup.querySelector(`.${PhotoComponent.CLASSES.PHOTO}`);
    this.$close = $popup.querySelector(`.${PopupComponent.CLASSES.CLOSE}`);
    this.$pageNumber = $popup.querySelector(`.${PopupComponent.CLASSES.PAGE_NUMBER}`);
    this.$buttonPrev = $popup.querySelector(`.${PopupComponent.CLASSES.BUTTON_PREV}`);
    this.$buttonNext = $popup.querySelector(`.${PopupComponent.CLASSES.BUTTON_NEXT}`);

    this.isOpen = $popup.classList.contains(PopupComponent.CLASSES.POPUP_OPEN);
    this.isLoading = $popup.classList.contains(PopupComponent.CLASSES.POPUP_LOADING);
    this.items = JSON.parse($popup.dataset.items || '[]');
    this.index = (this.$pageNumber && parseInt(this.$pageNumber.innerText.split('/')[0]) - 1) || 0;

    this.onResizeWindow = this.onResizeWindow.bind(this);
    this.onKeydownWindow = this.onKeydownWindow.bind(this);
    this.onClickClose = this.onClickClose.bind(this);
    this.onClickButtonPrev = this.onClickButtonPrev.bind(this);
    this.onClickButtonNext = this.onClickButtonNext.bind(this);

    this.init();
  }

  init() {
    if (this.$photo) {
      PhotoComponent.init(this.$photo);
    }

    window.addEventListener('resize', this.onResizeWindow);
    window.addEventListener('keydown', this.onKeydownWindow);
    this.$close.addEventListener('click', this.onClickClose);

    if (this.$buttonPrev) {
      this.$buttonPrev.addEventListener('click', this.onClickButtonPrev);
    }

    if (this.$buttonNext) {
      this.$buttonNext.addEventListener('click', this.onClickButtonNext);
    }
  }

  destroy() {
    window.removeEventListener('resize', this.onResizeWindow);
    window.removeEventListener('keydown', this.onKeydownWindow);
    this.$close.removeEventListener('click', this.onClickClose);

    if (this.$buttonPrev) {
      this.$buttonPrev.removeEventListener('click', this.onClickButtonPrev);
    }

    if (this.$buttonNext) {
      this.$buttonNext.removeEventListener('click', this.onClickButtonNext);
    }

    this.$popup.popupComponent = null;
    this.$popup.remove();
  }

  onResizeWindow() {
    this.resize();
  }

  onKeydownWindow(event) {
    let isEsc = event.code === 'Escape' || event.keyCode === 27;

    if (isEsc) {
      this.close();
    }
  }

  onClickClose() {
    this.close();
  }

  onClickButtonPrev() {
    this.prevSlide();
  }

  onClickButtonNext() {
    this.nextSlide();
  }

  resize() {
    if (this.$photo) {
      this.resizePhoto();
    }
  }

  resizePhoto() {
    if (!this.isOpen) {
      return;
    }

    let photoComponent = this.$photo.photoComponent;

    photoComponent.waitLoad().then(() => {
      let naturalWidth = photoComponent.$img.naturalWidth;
      let naturalHeight = photoComponent.$img.naturalHeight;
      let contentWidth = this.$content.offsetWidth;
      let contentHeight = this.$content.offsetHeight;
      let width = naturalWidth;
      let height = naturalHeight;
      let ratio = height / width;

      if (naturalWidth >= naturalHeight) {
        width = contentWidth;
        height = width * ratio;

        if (height > contentHeight) {
          height = contentHeight;
          width = height / ratio;
        }
      } else {
        height = contentHeight;
        width = height / ratio;

        if (width > contentWidth) {
          width = contentWidth;
          height = width * ratio;
        }
      }

      photoComponent.setSize(width, height);
    });
  }

  open() {
    if (this.isOpen) {
      return;
    }

    disableScroll();

    this.$popup.classList.add(PopupComponent.CLASSES.POPUP_OPEN);

    if (this.isLoading) {
      this.$popup.classList.add(PopupComponent.CLASSES.POPUP_LOADING);
    }

    this.isOpen = true;

    this.$photo.photoComponent.waitLoad().then(() => {
      this.resizePhoto();

      if (this.isLoading) {
        this.$popup.classList.remove(PopupComponent.CLASSES.POPUP_LOADING);
        this.isLoading = false;
      }
    });
  }

  close() {
    if (!this.isOpen) {
      return;
    }

    enableScroll();

    this.$popup.classList.remove(PopupComponent.CLASSES.POPUP_OPEN);
    this.isOpen = false;

    if (!this.$popup.classList.contains(PopupComponent.CLASSES.POPUP_PREPARED)) {
      this.destroy();
    }
  }

  updatePageNumber(number) {
    if (!this.$pageNumber) {
      return;
    }

    let length = this.items.length || 1;

    this.$pageNumber.innerText = `${number}/${length}`;
  }

  toSlide(index, {skipResize = false} = {}) {
    return new Promise((resolve) => {
      if (this.items.length < 2) {
        resolve();

        return;
      }

      index = normalizeIndex(index, this.items.length);

      if (index === this.index) {
        resolve();
        return;
      }

      this.index = index;

      if (this.$photo) {
        let photoComponent = this.$photo.photoComponent;

        photoComponent.update(this.items[index]).then(() => {
          if (!skipResize) {
            this.resizePhoto();
          }

          this.updatePageNumber(index + 1);
          resolve();
        });
      } else {
        resolve();
      }
    });
  }

  prevSlide() {
    this.toSlide(this.index - 1);
  }

  nextSlide() {
    this.toSlide(this.index + 1);
  }
}
